document.addEventListener('DOMContentLoaded', function () {
    const crossItems = document.querySelectorAll('[data-cross-selling]');
    const idSection = 'CrossQuickView';

    crossItems.forEach((el) => {
        el.addEventListener('click', function (e) {
            e.preventDefault();
            const { handle, title, description, price } = e.target.dataset;

            $Events.methods.addListener('custom::EditMounted', () => {

                $Events.methods.dispatchEvent('custom::crossQuickView', {
                    state: {
                        id: idSection,
                        handle: handle,
                        product_title: title,
                        product_description: description,
                        final_line_price: price,
                        quantity: 1,
                        editing: false
                    }
                });
            })
            setTimeout(() => {
                $Events.methods.dispatchEvent('custom::toggleModal', {
                    id: `edit-item-${idSection}`
                });
            }, 250);
        });
    });
});
